/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Change this to false if you want the good'ol cursor
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "JJ Lei",
  logo_name: "JJ Lei",
  nickname: "J",
  full_name: "JJ Lei",
  subTitle: "I am an AWS solutions architect, a game developer, and a dog lover.",
  resumeLink:
    "https://www.dropbox.com/s/5gkrjqutr19qjil/Junjie_Lei_Resume.pdf?dl=0",
  mail: "jj@jjlei.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/LAYTAT",
  linkedin: "https://www.linkedin.com/in/jjlei",
  gmail: "jj@jjlei.com",
  instagram: "https://www.instagram.com/superfly_jjjj/",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive Front end / User Interfaces for web and mobile applications",
        "⚡ Building responsive website front end using ReactJS",
        "⚡ Developing mobile applications using Flutter and Android",
        "⚡ Creating application backend in Node, Express & Flask",
        "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#7377AD",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        // {
        //   skillName: "GraphQL",
        //   fontAwesomeClassname: "simple-icons:graphql",
        //   style: {
        //     color: "#DE33A6",
        //   },
        // },
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Dart",
          fontAwesomeClassname: "simple-icons:dart",
          style: {
            color: "#29B0EE",
          },
        },
        // {
        //   skillName: "Visual Basic",
        //   fontAwesomeClassname: "simple-icons:dot-net",
        //   style: {
        //     color: "#029FCE",
        //   },
        // },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: {
            color: "#0865A6",
          },
        },
        {
          skillName: "Wordpress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#207297",
          },
        },
        {
          skillName: "Apache",
          fontAwesomeClassname: "simple-icons:apache",
          style: {
            color: "#CA1A22",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing websites",
        "⚡ Experience with Continuous Integration",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Johns Hopkins University",
      subtitle: "Master's Degree in Computer Science",
      logo_path: "jhu_wse.png",
      alt_name: "JHU",
      duration: "2021 - 2023",
      descriptions: [
        "⚡ During my master's degree, I completed several projects mainly focused on distributed systems, game server development, and full-stack development. These projects allowed me to apply my knowledge of computer science to solve complex problems in these areas. I collaborated with my classmates to design and implement distributed systems, game servers, and full-stack applications using various technologies and programming languages. These projects were challenging but rewarding, as they allowed me to gain hands-on experience in these fields and prepared me for a career in software development. Overall, these projects deepened my passion for technology and gave me a solid foundation to pursue my career goals.",
      ],
      website_link: "https://engineering.jhu.edu",
    },
    {
      title: "University of Florida",
      subtitle: "Exchange Student",
      logo_path: "UF_LOGO.png",
      alt_name: "UF_LOGO",
      duration: "2018",
      descriptions: [
        "⚡ I studied for 16 credit hours and worked in the UF ECE Lab as a research assistant.",
      ],
      website_link: "https://www.ecust.edu.cn/en/2022/0307/c574a164928/page.htm",
    },
    {
      title: "East China University of Science and Technology",
      subtitle: "Bachelor's degree in Software Engineering",
      logo_path: "ECUST_LOGO.png",
      alt_name: "ECUST_LOGO",
      duration: "2017 - 2020",
      descriptions: [
        "⚡ In my undergrad, I completed multiple software engineering projects where I applied programming skills and collaborated with peers to design, develop, and test software applications using diverse languages and tools. These challenging projects helped me gain hands-on experience in software development, project management, and prepared me for a career in software engineering, fueling my passion for innovative tech solutions. ",
      ],
      website_link: "https://www.ecust.edu.cn/en/2022/0307/c574a164928/page.htm",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "AWS Certified Solutions Architect – Professional",
      subtitle: "Earners of this certification have an extensive understanding of designing technical strategies to accomplish specific business goals.",
      logo_path: "AWS-SolArchitect-Pro.png",
      certificate_link:
        "https://www.credly.com/badges/180498a7-99fc-459c-9da5-d7f898d13fbd/public_url",
      alt_name: "AWS Solutions Architect Professional",
      color_code: "#146EB4",
    },
    {
      title: "AWS Certified Advanced Networking – Specialty",
      subtitle: "Earners of this certification have the ability to design and maintain network architecture for all AWS services. ",
      logo_path: "AWS-Network-Spec.png",
      certificate_link:
        "https://www.credly.com/badges/180498a7-99fc-459c-9da5-d7f898d13fbd/public_url",
      alt_name: "AWS Network Specialty",
      color_code: "#146EB4",
    },
    {
      title: "AWS Certified AI Practitioner",
      subtitle: "Earners of this certification demonstrate an understanding of AI/ML concepts and their implementation on AWS.",
      logo_path: "AWS-AI-Practitioner.png",
      certificate_link:
        "https://www.credly.com/users/junjie-lei.36160619/badges",
      alt_name: "AWS AI Practitioner",
      color_code: "#146EB4",
    },
    {
      title: "AWS Certified SysOps Administrator – Associate",
      subtitle: "Earners of this certification have a comprehensive understanding of deploying, managing, and operating scalable, highly available, and fault-tolerant systems on AWS.",
      logo_path: "AWS-SysOps-Associate.png",
      certificate_link:
        "https://www.credly.com/users/junjie-lei.36160619/badges",
      alt_name: "AWS SysOps Administrator",
      color_code: "#146EB4",
    },
    {
      title: "AWS Certified Developer – Associate",
      subtitle: "Earners of this certification have a comprehensive understanding of application life-cycle management.",
      logo_path: "AWS-Dev-Associate.png",
      certificate_link:
        "https://www.credly.com/badges/c23518d4-89e6-4f90-8004-89052127072b/public_url",
      alt_name: "AWS Developer Associate",
      color_code: "#146EB4",
    },
  ],
};

// Experience Page // TODO: add experience
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have a few years of professional experience and have also completed some internships, during which I worked on diverse projects. Currently, I am actively seeking tech positions, including roles as a Software Engineer or Cloud Architect. I am passionate about working on projects that have a tangible impact on our daily lives and strive to create meaningful solutions through technology.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Partner Solutions Architect",
          company: "Amazon Web Services",
          company_url: "https://aws.amazon.com",
          logo_path: "aws_logo.png",
          duration: "June 2023 - Present",
          location: "Seattle, Washington",
          description:
            "Enable AWS Partners to strengthen technical capabilities and deliver solutions on AWS. Specialize in Infrastructure as Code (IaC) using AWS CDK; guide partners on architecture patterns, best practices, and service adoption to meet business goals.",
          color: "#FF9900",
        },
        {
          title: "Game Software Engineer (C++)",
          company: "Ragnarok Origin Game Studio",
          company_url: "https://ragnarok-origin.com",
          logo_path: "ro.png",
          duration: "June 2020 - July 2021",
          location: "Shanghai, China",
          description:
            "Developed and optimized core server modules for the mobile MMORPG Ragnarok RO (global ranking, online payment, holiday task systems). Improved performance of the global ranking module by 20%. Optimized I/O multiplexing with epoll, increasing server CPU utilization efficiency by 10%. Designed a synchronization solution compensating for network latencies over 150ms.",
          color: "#0071C5",
        },
        {
          title: "Node.js Backend Software Engineer (Part-time)",
          company: "Miaowrite Tech (Startup)",
          company_url: "https://www.miaowrite.com",
          logo_path: "miaowrite.png",
          duration: "June 2019 - June 2020",
          location: "Shanghai, China",
          description:
            "Contributed to an online text editor for thesis writing. Implemented efficient conversion from DOM to custom data structures to improve editor performance. Reduced DB query time by 40% via verbose queries, indexing, and caching.",
          color: "#0071C5",
        },
      ],
    },
    // {
    //   title: "Other",
    //   experiences: [
    //     {
    //       title: "Community Lead",
    //       company: "Bauddhik-Geeks",
    //       company_url: "https://bauddhikgeeks.tech/",
    //       logo_path: "bauddhikgeeks.png",
    //       duration: "Sep 2021 - Present",
    //       location: "Work From Home",
    //       description:
    //         "Help Tech-Geeks so they get exposure to the technical world and enlighten their skills. Hence, the programming club highlight all the skills of the individual members and help them develop and groom their skills in a meaningful way. Help community members to learn and grow.",
    //       color: "#FBBD18",
    //     },
    //     {
    //       title: "Cross Winter of Code Mentor",
    //       company: "CWOC",
    //       company_url: "https://crosswoc.ieeedtu.in/",
    //       logo_path: "cwoc.png",
    //       duration: "Feb 2021 - Present",
    //       location: "Work From Home",
    //       description:
    //         "Mentorship responsibilities were to help students plan the project, review issues and pull requests, ensure smooth progress and help them out when they are stuck.",
    //       color: "#4285F4",
    //     },
    //     // {
    //     //   title: "Campus Hustler",
    //     //   company: "Skillenza",
    //     //   company_url: "https://skillenza.com/",
    //     //   logo_path: "skillenza.png",
    //     //   duration: "Feb 2021 - Present",
    //     //   location: "Work from Home",
    //     //   description:
    //     //     "Spread Awareness of new Technologies and new Opportunities to Students and Grow Skillenza Community.",
    //     //   color: "#196acf",
    //     // },
    //     {
    //       title: "GDG Student Volunteer",
    //       company: "Google Developer Groups",
    //       company_url: "https://gdg.community.dev/",
    //       logo_path: "gdg.png",
    //       duration: "Feb 2021 - Present",
    //       location: "Work From Home",
    //       description:
    //         "Google Developer Group Surat Student Volunteer and Member.",
    //       color: "#D83B01",
    //     },
    //     {
    //       title: "Postman Student Expert",
    //       company: "Postman",
    //       company_url: "https://www.postman.com/",
    //       logo_path: "postman.png",
    //       duration: "Feb 2020 - Present",
    //       location: "Work From Home",
    //       description:
    //         "Google Developer Group Surat Student Volunteer and Member.",
    //       color: "#D83B01",
    //     },
    //     {
    //       title: "GitHub Student Developer",
    //       company: "GitHub",
    //       company_url: "https://github.com/",
    //       logo_path: "github.png",
    //       duration: "Nov 2019 - Present",
    //       location: "Work from Home",
    //       description:
    //         "Contribute to Open Source Community and Open Source Project.",
    //       color: "#040f26",
    //     },
    //     {
    //       title: "Google Local Guide",
    //       company: "Google Map",
    //       company_url: "https://maps.google.com/localguides/",
    //       logo_path: "localguide.png",
    //       duration: "Sep 2018 - Present",
    //       location: "Work From Home",
    //       description:
    //         "Day-to-day responsibilities of helping local businesses to spread their business to the world. Helping users by writing reviews about different locations and spaces such as shops, malls, etc.",
    //       color: "#D83B01",
    //     },
    //     {
    //       title: "E. F. I. Student Volunteer",
    //       company: "ENVIRONMENTALIST FOUNDATION OF INDIA",
    //       company_url: "https://indiaenvironment.org/",
    //       logo_path: "efi.png",
    //       duration: "Apr 2017 - Present",
    //       location: "Work From Home",
    //       description:
    //         "Take time out over weekends to join a gang of nation builders, nature enthusiasts to conserve what is left.",
    //       color: "#5a900f",
    //     },
    //   ],
    // },
  ],
};

// Projects Page // TODO: add projects
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create C++ software, NodeJS Backend Projects, Python Scripts, and React Project. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page // TODO: add Contact
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "jjl.png",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I have written technical blogs on AWS, Cloud Infrastructure, and VR Systems. Check them out below:",
    link: "https://www.linkedin.com/in/jj-lei-b8434718b/",
    avatar_image_path: "blogs_image.svg",
    blogs: [
      {
        url: "https://jhu-dsn.github.io/courses/cs717/cs717-oculus-website/",
        title: "Low-Latency HCI with Real-Time VR Latency",
        description: "Research on optimizing interaction latency in virtual reality environments."
      },
      {
        url: "https://aws.amazon.com/blogs/devops/safely-handle-configuration-drift-with-cloudformation-drift-aware-change-sets/",
        title: "Cloud Infra Drift Control",
        description: "Safely handling configuration drift with CloudFormation."
      },
      {
        url: "https://aws.amazon.com/blogs/devops/a-new-aws-cdk-l2-construct-for-amazon-cloudfront-origin-access-control-oac/",
        title: "Edge Delivery (OAC)",
        description: "Secure CloudFront origins with Origin Access Control (OAC) via AWS CDK."
      },
      {
        url: "https://docker.awsworkshop.io/",
        title: "Container Compute Systems",
        description: "A comprehensive workshop guide on AWS container services."
      }
    ]
  },
};

const projects = {  // TODO: add projects
  data: [
    {
      id: "0",
      name: "Reliable UDP Multicast",
      url: "https://github.com/LAYTAT/Reliable-UDP-Multicast-Demo",
      description:
      "A fast and reliable way to multicast data using the UDP protocol, which can be used as part of a larger infrastructure for synchronizing data between servers. ",
      languages: [
        {
          name: "C",
          iconifyClass: "mdi:language-c",
        },
        {
          name: "C++",
          iconifyClass: "vscode-icons:file-type-cpp2",
        },
        {
          name: "UDP",
          iconifyClass: "carbon:tcp-ip-service",
        },
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
        // {
        //   name: "CSS3",
        //   iconifyClass: "logos-css-3",
        // },
        // {
        //   name: "NodeJs",
        //   iconifyClass: "logos-nodejs",
        // }
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/LAYTAT/Reliable-UDP-Multicast-Demo",
          iconifyClass: "ri:github-fill",
        },
        // {
        //   name: "Devpost",
        //   url: "https://github.com/LAYTAT",
        //   iconifyClass: "fluent:window-dev-edit-20-filled",
        // },
        // {
        //   name: "Live Demo",
        //   url:
        //     "https://github.com/LAYTAT",
        //   iconifyClass: "mdi:web",
        // },
      ],
    },
    {
      id: "1",
      name: "Small-Gaming-Server-Demo",
      url: "https://github.com/LAYTAT/Small-Gaming-Server-Demo",
      description:
        "This is a small but scalable gaming server.",
      languages: [
        {
          name: "C",
          iconifyClass: "mdi:language-c",
        },
        {
          name: "C++",
          iconifyClass: "vscode-icons:file-type-cpp2",
        },
        {
          name: "Socket",
          iconifyClass: "logos:websocket",
        },
        {
          name: "UDP",
          iconifyClass: "carbon:tcp-ip-service",
        },
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/LAYTAT/Small-Gaming-Server-Demo",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Devfolio",
          url: "https://github.com/LAYTAT/Small-Gaming-Server-Demo",
          iconifyClass: "fluent:window-dev-edit-20-filled",
        },
      ],
    },
    {
      id: "2",
      name: "Mail Sync",
      url: "https://github.com/LAYTAT/mail_system",
      description:
        "This system provides fault-tolerant email service by replicating emails across multiple servers to prevent data loss in case of a (network) failure.",
      languages: [
        {
          name: "C",
          iconifyClass: "mdi:language-c",
        },
        {
          name: "C++",
          iconifyClass: "vscode-icons:file-type-cpp2",
        },
        {
          name: "Socket",
          iconifyClass: "logos:websocket",
        },
        {
          name: "UDP",
          iconifyClass: "carbon:tcp-ip-service",
        },
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/LAYTAT/Small-Gaming-Server-Demo",
          iconifyClass: "ri:github-fill",
        }
      ],
    },
    {
      id: "3",
      name: "A LITTLE AR GAME",
      url: "https://github.com/LAYTAT/A-LITTLE-AR-GAME",
      description:
        "This is a mobile action game that could run on your physical desks, check it out!",
      languages: [
        {
          name: "Unity Engine",
          iconifyClass: "mdi:unity",
        },
        {
          name: "C#",
          iconifyClass: "logos:c-sharp",
        },
        {
          name: "Android",
          iconifyClass: "ri:android-fill",
        },
        {
          name: "Augmented Reality",
          iconifyClass: "bi:badge-ar",
        },
        {
          name: "C++",
          iconifyClass: "vscode-icons:file-type-cpp2",
        },
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/LAYTAT/A-LITTLE-AR-GAME",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Devpost",
          url: "https://github.com/LAYTAT/A-LITTLE-AR-GAME",
          iconifyClass: "fluent:window-dev-edit-20-filled",
        },
      ],
    },
    {
      id: "4",
      name: "VR Game Latency Optimizer",
      url: "https://www.dsn.jhu.edu/courses/cs717/cs717-oculus-website/",
      description:
        "This is an VR game with a server system implemented to demonstrate a method to optimize the latency for online games, especially for VR experiences (not just games).",
      languages: [
        // {
        //   name: "HTML5",
        //   iconifyClass: "logos-html-5",
        // },
        // {
        //   name: "CSS3",
        //   iconifyClass: "logos-css-3",
        // },
        {
          name: "Virtual Reality",
          iconifyClass: "bi:badge-vr",
        },
        {
          name: "C#",
          iconifyClass: "logos:c-sharp",
        },
        {
          name: "Android",
          iconifyClass: "ri:android-fill",
        },
        {
          name: "Oculus",
          iconifyClass: "gg:oculus",
        },
        {
          name: "C++",
          iconifyClass: "vscode-icons:file-type-cpp2",
        },
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
      ],
      links: [
        // {
        //   name: "Github",
        //   url: "https://github.com/LAYTAT",
        //   iconifyClass: "ri:github-fill",
        // },
        {
          name: "Devpost",
          url: "https://www.dsn.jhu.edu/courses/cs717/cs717-oculus-website/",
          iconifyClass: "fluent:window-dev-edit-20-filled",
        },
      ],
    },
    {
      id: "5",
      name: "Fileblok",
      url: "https://github.com/LAYTAT",
      description:
        "Keep your projects moving with seamless transfer experice. FileBlok is a file transfer app that allows you to transfer files from one device to another without any hassle. We built this app using Flutter, Node.js and StoryBlok.",
      languages: [
        {
          name: "Flutter",
          iconifyClass: "logos-flutter",
        },
        {
          name: "NodeJs",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "Storyblok",
          iconifyClass: "logos-storyblok-icon",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/LAYTAT",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Devpost",
          url: "https://github.com/LAYTAT",
          iconifyClass: "fluent:window-dev-edit-20-filled",
        },
      ],
    },
    // {
    //   id: "6",
    //   name: "BAUDDIK-GEEKS PORTFOLIO",
    //   url: "https://github.com/LAYTAT",
    //   description:
    //     "Awesome Community Portfolio website for Bauddhik-Geeks community",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "https://github.com/LAYTAT",
    //       iconifyClass: "ri:github-fill",
    //     },
    //     {
    //       name: "Live Demo",
    //       url: "https://github.com/LAYTAT",
    //       iconifyClass: "mdi:web",
    //     },
    //   ],
    // },
    {
      id: "6",
      name: "Votechain",
      url: "https://github.com/LAYTAT",
      description:
        "Awesome Community Portfolio website for Bauddhik-Geeks community",
      languages: [
        {
          name: "Flask",
          iconifyClass: "logos-flask",
        },
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS3",
          iconifyClass: "logos-css-3",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb-icon",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/LAYTAT",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    {
      id: "7",
      name: "Swag Store",
      url: "https://github.com/LAYTAT",
      description:
        "An E-commerce website built using MERN[Mongo, Express, React, Node] stack and we have also added stripe payment gateway integration [in test mode].",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "MedusaJS",
          iconifyClass: "logos-medusa-icon",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/LAYTAT",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    // {
    //   id: "9",
    //   name: "node-blockchain",
    //   url: "https://github.com/LAYTAT",
    //   description:
    //     "A simple blockchain and cryptocurrency wallet implemented in Node.js and TypeScript (for learning purposes).",
    //   languages: [
    //     {
    //       name: "NodeJS",
    //       iconifyClass: "logos-nodejs",
    //     },
    //     {
    //       name: "TypeScript",
    //       iconifyClass: "skill-icons:typescript",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "https://github.com/LAYTAT",
    //       iconifyClass: "ri:github-fill",
    //     },
    //   ],
    // },
    // {
    //   id: "10",
    //   name: "Know Me Well",
    //   url: "https://github.com/LAYTAT",
    //   description:
    //     "A simple command line interface based quiz app to know more about me :).",
    //   languages: [
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "NodeJS",
    //       iconifyClass: "logos-nodejs",
    //     },
    //     {
    //       name: "Repl.it",
    //       iconifyClass: "logos-replit-icon",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "https://github.com/LAYTAT",
    //       iconifyClass: "ri:github-fill",
    //     },
    //   ],
    // },
    // {
    //   id: "11",
    //   name: "Bloggify",
    //   url: "https://github.com/LAYTAT",
    //   description: "A Simple REST API for Blog Application.",
    //   languages: [
    //     {
    //       name: "NodeJS",
    //       iconifyClass: "logos-nodejs",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "https://github.com/LAYTAT",
    //       iconifyClass: "ri:github-fill",
    //     },
    //   ],
    // },
    // {
    //   id: "12",
    //   name: "Stargazzers",
    //   url: "https://github.com/LAYTAT",
    //   description: "An Unofficial API for GitHub Repo Stars Count",
    //   languages: [
    //     {
    //       name: "NodeJs",
    //       iconifyClass: "logos-nodejs",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "https://github.com/LAYTAT",
    //       iconifyClass: "ri:github-fill",
    //     },
    //   ],
    // },
    // {
    //   id: "13",
    //   name: "GitHub Theme Portfolio",
    //   url: "https://github.com/LAYTAT",
    //   description:
    //     "A Personal Portfolio Website that showcases my work and experience. which is hosted on Github Pages.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "SCSS",
    //       iconifyClass: "vscode-icons:file-type-scss2",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "https://github.com/LAYTAT",
    //       iconifyClass: "ri:github-fill",
    //     },
    //     {
    //       name: "Live Demo",
    //       url: "https://github.com/LAYTAT",
    //       iconifyClass: "mdi:web",
    //     },
    //   ],
    // },
    // {
    //   id: "10",
    //   name: "COVID-19 Tracker",
    //   url: "https://github.com/LAYTAT",
    //   description:
    //     "Simple Covid-19 Tracker made using React and deployed to Vercel.",
    //   languages: [
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "HTML5",
    //       iconifyClass: "logos-html-5",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "logos-css-3",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "https://github.com/LAYTAT",
    //       iconifyClass: "ri:github-fill",
    //     },
    //   ],
    // },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
